import type { BillingMode } from '../../../types/admin';

export function billingModeNote(mode: BillingMode): string {
  if (mode === 'none') return 'System jobs without a user: logged, never charged.';
  if (mode === 'metered')
    return 'Quota is prechecked and the user is charged 100% of real usage cost (credits), the same as a normal chat call.';
  return '';
}
